import List from '@mui/material/List';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@repo/mui-config/hooks';
import { loanResponseConfigParametersNames } from '@repo/shared/types';
import { colorPalette } from '@repo/mui-config/color-palette';
import { MerchantResponse } from '@repo/api/endpoints/merchant';

const userDetailsListFields = [
  loanResponseConfigParametersNames.enum.documentId,
  loanResponseConfigParametersNames.enum.phone,
  loanResponseConfigParametersNames.enum.mail,
];

export const LiberisRecipientDetailsList = ({
  merchantResponseData,
}: {
  merchantResponseData: MerchantResponse;
}) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  const displayBackgroundColor = (index: number) => {
    if (index % 2 === 0) {
      return colorPalette.cloud.light;
    }

    return undefined;
  };

  const getRecipientDetailsData = {
    documentId: merchantResponseData.data.merchantData.representative[0].document.number,
    mail: merchantResponseData.data.merchantData.email,
    phone: merchantResponseData.data.merchantData.phone,
  };

  return (
    <List>
      {userDetailsListFields?.map((field, index) => {
        const fieldError = !getRecipientDetailsData[field];

        return (
          <ListItem
            key={`liberis-detail-field-${field}`}
            sx={{
              p: '10px 24px',
              borderRadius: '10px',
              backgroundColor: displayBackgroundColor(index),
            }}
          >
            <Grid
              alignItems={isMobile ? 'flex-start' : 'center'}
              container
              flexDirection={isMobile ? 'column' : 'row'}
              marginBlock={{ xs: '0px', lg: '10px', xl: '0px' }}
              sx={{ width: '100%' }}
            >
              <Grid size={{ xs: 12, md: 6 }}>
                <Box>
                  <Typography variant="textField">
                    {t(`welcomePage.loanApplicationPossible.liberis.checkYourData.fields.${field}`)}
                  </Typography>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Typography
                  color={fieldError ? colorPalette.error.main : colorPalette.ink.light}
                  data-testid={`detail-field-${field}`}
                  variant="textField"
                >
                  {fieldError
                    ? t(
                        `welcomePage.loanApplicationPossible.liberis.checkYourData.fieldsErrors.${field}`,
                      )
                    : getRecipientDetailsData[field]}
                </Typography>
              </Grid>
            </Grid>
          </ListItem>
        );
      })}
    </List>
  );
};
